import { RootAppState } from 'store/types';

export const getTreeOfContentVisibility = (state: RootAppState) => state.treeOfContent.isExpanded; // eslint-disable-line
